import React from "react";
import { Button, Image, Form, Row } from "react-bootstrap";
import { Switch, Route, Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { I18n } from "../utils/I18n";
import AlertDialog from "../utils/AlertDialog";

import UserProtocol from "../net/UserProtocol";

const root = process.env.PUBLIC_URL + "/";

export default class LoginPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userEmail: "",
      userPwd: "",

      showMsgModal: false,
      modalTitle: "",
      modalMsg: "",
    };

    console.log("create login panel");
  }
  componentDidMount() {
    // alert('login');
  }

  render() {
    return (
      <Row
        className="align-items-end"
        style={{
          height: "100vh",
          backgroundImage: 'url("' + root + 'images/login_bg.jpg")',
        }}
      >
        <div className="col-12">
          <div
            className="col-xl-3 mx-auto text-secondary p-0"
            style={{ borderRadius: "30px", boxShadow: "3px 3px 5px black" }}
          >
            <Switch>
              <Route path="/ForgetPwd">{this.ForgetPwdForm()}</Route>
              <Route path="/">
                <div
                  className="col-xl-12 mx-auto text-secondary p-0"
                  style={{ borderRadius: "30px 30px 0px 0px" }}
                >
                  <Image
                  className="col-xl-12 mx-auto text-secondary p-0"
                    src={root + "4.png"}
                    style={{ maxHeight: "100%", maxWidth: "100%" }}
                    fluid
                  />
                </div>
                <div
                  className="col-xl-12 mx-auto text-secondary p-0 bg-light p-4"
                  style={{ borderRadius: "0px 0px 30px 30px" }}
                >
                  {" "}
                  {this.LoginForm()}
                </div>
              </Route>
            </Switch>
          </div>
        </div>
        <footer
          className="col-12 text-light p-2"
          style={{ backgroundColor: "#0032A0" }}
        >
          <Row className="col-12" style={{ fontSize: "20px" }}>
            <b style={{ position: "absolute", left: "30px" }}>
              <FormattedMessage id="global.appName" />
            </b>
            <div className="mx-auto">
              <FormattedMessage id="global.copyright" />
            </div>
          </Row>
        </footer>
      </Row>
    );
  }

  LoginForm() {
    return (
      <Form>
        <Form.Group controlId="email" style={{ marginTop: "10%" }}>
          <Form.Control
            type="email"
            placeholder={I18n.t("loginPage.email")}
            size="lg"
            value={this.state.userEmail}
            onChange={(e) => this.setState({ userEmail: e.target.value })}
          />
        </Form.Group>
        <Form.Group controlId="pwd">
          <Form.Control
            type="password"
            placeholder={I18n.t("loginPage.password")}
            size="lg"
            value={this.state.userPwd}
            onChange={(e) => this.setState({ userPwd: e.target.value })}
          />
        </Form.Group>
        <Button
          variant="outline-light"
          style={{ boxShadow: "2px 2px 10px #333", backgroundColor: "#0032A0" }}
          size="lg"
          block
          onClick={() => {
            if (this.state.userEmail === "") {
              AlertDialog.show(
                I18n.t("msg.login.ErrTitle"),
                I18n.t("msg.login.ErrEmailEmpty")
              );
              return;
            } else if (this.state.userPwd === "") {
              AlertDialog.show(
                I18n.t("msg.login.ErrTitle"),
                I18n.t("msg.login.ErrPwdEmpty")
              );
              return;
            }
            // alert("vectorinc");

            UserProtocol.ins().reqLogin(
              this.state.userEmail,
              this.state.userPwd,
              (data) => {
                if (data != 200) {
                  //this.props.screenProps.onLogin(this.state.userEmail);
                  AlertDialog.show(I18n.t("msg.login.ErrTitle"), I18n.t("msg.login.ErrPwdEmail"));
                  console.log("login err code : "+data)
                  return;
                } else {
                  this.props.screenProps.onLogin(this.state.userEmail);
                }
              }
            );
            //for test
          }}
        >
          <FormattedMessage id="loginPage.login" />
        </Button>
        <br />
        <Row className="m-0 justify-content-between">
          <Form.Check
            type="checkbox"
            id="formBasicCheckbox"
            label={I18n.t("loginPage.rememberPwd")}
            custom
          />
          <Link to="/ForgetPwd" className="text-secondary">
            <FormattedMessage id="loginPage.forgetPwd" />
          </Link>
        </Row>
      </Form>
    );
  }

  ForgetPwdForm() {
    return (
      <Form>
        <Form.Group controlId="email">
          <Form.Control
            type="email"
            placeholder={I18n.t("loginPage.email")}
            size="lg"
            value={this.state.userEmail}
            onChange={(e) => this.setState({ userEmail: e.target.value })}
          />
        </Form.Group>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            if (this.state.userEmail === "") {
              AlertDialog.show(
                I18n.t("msg.forgetPwd.Title"),
                I18n.t("msg.login.ErrEmailEmpty")
              );
              return;
            }

            //for test
            AlertDialog.show(
              I18n.t("msg.forgetPwd.Title"),
              I18n.t("msg.forgetPwd.SendMailDone", {
                email: this.state.userEmail,
              })
            );
          }}
        >
          <FormattedMessage id="loginPage.sendResetPwd" />
        </button>
      </Form>
    );
  }
}
